<!-- 设置公式 -->
<template>
  <div>
    <el-dialog
      width="600px"
      title="设置公式"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <el-form ref="refForm" label-width="100px">
          <el-form-item label="计算公式:" class="p-y-5">
            <el-input
              v-model="formulaStr"
              type="textarea"
              size="mini"
              resize="none"
              :rows="4"
              disabled
            />
            <div class="btn-delete">
              <el-link
                class="btn-delete-one"
                type="primary"
                size="mini"
                icon="el-icon-circle-close"
                title="删除最后格"
                @click="btnDelete"
              >
                删格
              </el-link>
              <el-link
                class="btn-delete-all"
                type="primary"
                size="mini"
                icon="el-icon-delete"
                title="清空所有"
                @click="btnClear"
              >
                清空
              </el-link>
            </div>
          </el-form-item>
          <el-form-item v-if="data.mi_du_shi_li" label="密度参数:" class="contral-main">
            <el-button type="default" size="mini" @click="contralChoose('密度')"> 密度 </el-button>
          </el-form-item>
          <el-form-item label="规格参数:" class="contral-main">
            <div v-for="(itemSt, indexSt) in chooseSpecList" :key="indexSt">
              <el-button
                v-for="(itemNd, indexNd) in itemSt"
                :key="indexNd"
                type="default"
                size="mini"
                @click="contralChoose(itemNd.key)"
              >
                {{ itemNd.key }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item v-if="fuJiaCanShuList.length" label="附加参数:" class="contral-main">
            <div>
              <el-button
                v-for="(itemSt, indexSt) in fuJiaCanShuList"
                :key="indexSt"
                type="default"
                size="mini"
                @click="contralChoose(itemSt.key)"
              >
                {{ itemSt.key }}
              </el-button>
            </div>
          </el-form-item>
          <template v-if="false">
            <el-form-item label="价格参数:" class="contral-main">
              <el-button type="default" size="mini" @click="contralChoose('基价')">
                基价
              </el-button>
            </el-form-item>
            <el-form-item label="商品参数:" class="contral-main">
              <el-button
                v-for="(item, index) in btnListShangPin"
                :key="index"
                type="default"
                size="mini"
                @click="contralChoose(item)"
              >
                {{ item }}
              </el-button>
            </el-form-item>
            <el-form-item label="物料参数:" class="contral-main symbol">
              <el-button
                v-for="(item, index) in btnListWuLiao"
                :key="index"
                type="default"
                size="mini"
                @click="contralChoose(item)"
              >
                {{ item }}
              </el-button>
            </el-form-item>
            <el-form-item label="加工参数:" class="contral-main symbol">
              <el-button
                v-for="(item, index) in btnListJiaGong"
                :key="index"
                type="default"
                size="mini"
                @click="contralChoose(item)"
              >
                {{ item }}
              </el-button>
            </el-form-item>
          </template>
          <el-form-item label="符号控件:" class="contral-main symbol">
            <el-button
              v-for="(item, index) in btnListFuHao"
              :key="index"
              type="default"
              size="mini"
              @click="contralChoose(item)"
            >
              {{ item }}
            </el-button>
          </el-form-item>
          <el-form-item label="数值控件:" class="contral-main symbol">
            <el-button
              v-for="(item, index) in btnListShuZhi"
              :key="index"
              type="default"
              size="mini"
              @click="contralChoose(item)"
            >
              <span v-if="item === '√3'" class="gen-hao-3">
                <span class="gen-hao-l">√</span>
                <span class="gen-hao-r">3</span>
              </span>
              <span v-else>{{ item }}</span>
            </el-button>
          </el-form-item>
          <el-form-item label="数值输入:" class="contral-main symbol">
            <div class="flex flex-y-center m-t-5">
              <el-button
                v-for="(item, index) in btnListShuRu"
                :key="index"
                type="default"
                size="mini"
                @click="shuRuChoose(item)"
              >
                {{ item }}
              </el-button>
            </div>
            <div class="flex flex-y-center">
              <el-input class="shu-ru-input" size="mini" clearable v-model.trim="shuRuVal" />
              <el-button type="success" size="mini" @click="shuRuConfirm"> 确认 </el-button>
              <el-button size="mini" @click="shuRuDelete"> 删除 </el-button>
              <el-button size="mini" @click="shuRuClear"> 清空 </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => {
        return {
          // data.gui_ge_list 规格
          // data.mi_du_shi_li 密度示例
        }
      }
    },
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfList: [],
      btnListShangPin: ['单件数量', '单价', '单件金额'],
      btnListWuLiao: ['物料总价'],
      btnListJiaGong: ['加工总价', '分切数量', '零件材料单价', '尾料长度'],
      btnListFuHao: ['+', '-', '*', '/', '(', ')'],
      btnListShuZhi: ['2', '4', 'π', '√3', '²', '³', '1000'],
      btnListShuRu: ['.', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
      shuRuVal: ''
    }
  },
  computed: {
    // 公式字符串
    formulaStr() {
      let result = `${this.name}=${this.selfList.join('')}`
      return result
    },
    // 选择规格列表
    chooseSpecList() {
      let result = []
      let resultYes = []
      let resultNo = []
      let useList = this.data.gui_ge_list || []
      let allList = this.$util.deepCopy(this.$constant.shangPinMuBanGuiGeList)
      if (useList.length) {
        allList.forEach((item) => {
          let index = useList.indexOf(item.key)
          if (index > -1) {
            useList.forEach((uItem, uIndex) => {
              if (uItem === item.key) resultYes[uIndex] = this.$util.deepCopy(item)
            })
          } else {
            resultNo.push(this.$util.deepCopy(item))
          }
        })
      } else {
        resultNo = allList
      }
      result.push(resultYes)
      // result.push(resultNo)
      return result
    },
    fuJiaCanShuList() {
      let result = []
      this.data.fu_jia_can_shu_list.map((item) => {
        let obj = { key: item.name, val: item.name }
        result.push(obj)
      })
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.selfList = this.$util.deepCopy(this.list)
  },
  methods: {
    // 栅格
    btnDelete() {
      this.selfList.splice(this.selfList.length - 1, 1)
    },
    // 清空
    btnClear() {
      this.selfList.splice(0, this.selfList.length)
    },
    // 控件选择
    contralChoose(val) {
      if (val === 'π') val = '3.14159'
      if (val === '√3') val = '1.73205'
      this.selfList.push(val)
    },
    // 输入选择
    shuRuChoose(val) {
      this.shuRuVal = `${this.shuRuVal}${val}`
    },
    // 输入删除
    shuRuDelete() {
      this.shuRuVal = this.shuRuVal.slice(0, -1)
    },
    // 输入清空
    shuRuClear() {
      this.shuRuVal = ''
    },
    // 输入确认
    shuRuConfirm() {
      if (!this.shuRuVal) return
      this.selfList.push(this.shuRuVal)
      this.shuRuVal = ''
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$emit('update:list', this.selfList)
      this.popupCancel()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  /deep/ .el-textarea.is-disabled .el-textarea__inner {
    color: inherit;
  }
  .shu-ru-input {
    width: 223px;
    margin-right: 5px;
  }
  .btn-delete {
    position: absolute;
    right: 0;
    bottom: 0;
    line-height: 28px;
    .btn-delete-one,
    .btn-delete-all {
      line-height: 1.5;
      margin-right: 10px;
    }
  }
  .contral-main {
    /deep/ .el-button {
      min-width: 28px;
      margin-right: 5px;
      & ~ .el-button {
        margin-left: 0;
      }
    }
    .gen-hao-3 {
      .gen-hao-l {
        font-family:
          PingFang SC,
          sans-serif;
      }
      .gen-hao-r {
        margin-left: -6px;
        font-size: 10px;
      }
    }
  }
}
</style>
